import { UserDetail } from '@/modules/users/user-detail'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_public/_layout/users/$user')({
  component: UserDetail,
})
